import { ProfileUpload } from '../../../shared/ProfileUpload';

export default ProfileUpload;
